// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/** EnergyFluo fault + root-cause brief (POST /api/v1/ai/alarm-brief). */

import { post } from './api';
import { ENDPOINTS } from '../utils/constants';

export interface AlarmBriefRequest {
  site_id: string;
  alarm_code: string;
  alarm_id?: string | null;
  event_type?: 'alarm' | 'anomaly' | null;
  bound_sops?: string[];
  rule_title?: string | null;
  category?: string | null;
  priority?: string | null;
  control_layer?: string | null;
}

export interface AlarmBrief {
  fault: string | null;
  root_cause: string | null;
  confidence: 'high' | 'medium' | 'low';
  /** Unconfirmed causes from SOPs and manuals; only set when no root cause was found. */
  possible_causes: string[];
}

export const getAlarmBrief = (payload: AlarmBriefRequest): Promise<AlarmBrief> =>
  post<AlarmBrief>(ENDPOINTS.AI_ALARM_BRIEF, payload);
